<template>
  <div>
    <div class=" w-full mt-2">
      <p class="font-black text-xs mb-2 uppercase">
        {{ title }}
      </p>
      <div v-if="employeeReliefs.length > 0 || employeeReliefsHistory.length > 0" class="line"></div>
    </div>
    <Tab v-if="employeeReliefs.length > 0 || employeeReliefsHistory.length > 0" 
      :tabs="tabs" border :active-tab="currentTab" @currentTab="currentTab = $event" 
    />

    <loader v-if="isLoading" size="xxs" :loader-image="false" />
    <div v-else>
      <div v-if="currentTab === 'Current Relief'">
        <table v-if="employeeReliefs.length > 0" aria-label="other benefits table" class="w-full mt-6">
          <thead>
            <tr>
              <th id="0">#</th>
              <th class=" uppercase" v-for="(header, index) in headers" :key="index" :id="index">
                <p>{{ header.title }}</p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, i) in  employeeReliefs" :key="i" class="tableBody text-sm" style="height: 48px; ">
              <td>
                {{ i + 1 }}
              </td>
              <td class="capitalize">
                {{ data.name ? data.name : `----` }}
              </td>
              <td>
                {{ data.amount ? convertToCurrency(data.amount) : `----` }}
              </td>
              <td>
              {{ data.createdAt ?
                  `${$DATEFORMAT(
                    new Date(data.createdAt),
                    "MMMM dd, yyyy"
                  )}` : `----`
                }}
              </td>
              <td class="flex flex-col">
                <span class="font-semibold text-sm uppercase">
                  {{ data.lastUpdatedBy ? `${data.lastUpdatedBy.fname} ${data.lastUpdatedBy.lname}` : `----`}}
                </span>
                <span class="text-xs text-blueCrayola">
                  {{ data.updatedAt ? `${$DATEFORMAT(new Date(data.updatedAt), "MMMM dd, yyyy")}` : `----` }}
                </span>
              </td>
              <td>
                <span
                  class="grosspay capitalize font-semibold"
                  :style="{
                      backgroundColor: data.status === 'approved' ? `#13B56A14` :
                        data.status === 'disapproved' ? `#EA3C5314` :
                        data.status === 'pending' ? `#E9932314` : `#13B56A26`,
                      color: data.status === 'approved' ? `#13B56A` :
                        data.status === 'disapproved' ? `#EA3C53`:
                        data.status === 'pending' ? `#E99323` : `#13B56A`,
                    }"
                >
                  {{ data.status === 'pending' ? 'pending' :
                    data.status === 'approved' ? 'validated' :
                    data.status === 'disapproved' ? 'invalidated' : `-----`}}
                </span>
              </td>
              <td class="text-blueCrayola">
                <div v-if="data.fileName" @click="viewFile(data.fileUrl)" class="flex cursor-pointer gap-1">
                  <div>
                    <icon icon-name="doc" size="s" class="w-5 h-5 rounded" v-if="data.fileMimeType.includes('doc')"/>
                    <icon icon-name="xlsx" size="s" class="w-5 h-5 rounded" v-else-if="data.fileMimeType.includes('xlsx')"/>
                    <icon icon-name="xlsx" size="s" class="w-5 h-5 rounded" v-else-if="data.fileMimeType.includes('vnd.ms-excel')"/>
                    <icon icon-name="csv" size="s" class="w-5 h-5 rounded" v-else-if="data.fileMimeType.includes('csv')"/>
                    <icon icon-name="png" size="s" class="w-5 h-5 rounded" v-else-if="data.fileMimeType.includes('png')"/>
                    <icon icon-name="ppt" size="s" class="w-5 h-5 rounded" v-else-if="data.fileMimeType.includes('ppt')"/>
                    <icon icon-name="pdf" size="s" class="w-5 h-5 rounded" v-else-if="data.fileMimeType.includes('pdf')"/>
                    <icon icon-name="jpg" size="s" class="w-5 h-5 rounded" v-else-if="data.fileMimeType.includes('jpg')"/>
                    <icon icon-name="jpg" size="s" class="w-5 h-5 rounded" v-else-if="data.fileMimeType.includes('jpeg')"/>
                  </div>
                  <span>
                    {{  data.fileName && data.fileName.length > 12 ? data.fileName.slice(0, 12) + '...' : data.fileName }}
                  </span>
                </div>
                <span v-else>----</span>
              </td>
              <td>
                <Menu v-if="canEdit" left top="-150" margin="24" class="my-2 p-0">
                  <template v-slot:title>
                    <icon icon-name="more_icon" size="xs" />
                  </template>
                    <div class="w-48 flex flex-col justify-start items-center gap-3 px-3 py-2" v-if="data.status === 'pending'">
                      <div v-if="canValidateOrInvalidate" class="w-full" @click="viewRelief(data)">
                        <div class="w-full flex justify-start items-center gap-2 cursor-pointer">
                          <Icon icon-name="icon-eye" class-name="text-blueCrayola" size="xs" />
                          <p class="font-normal text-sm text-darkPurple">View</p>
                        </div>
                      </div>
                      <div v-if="canValidateOrInvalidate" class="w-full" @click="updateReliefsStatus(data.id, 'approved')">
                        <div class="w-full flex justify-start items-center gap-2 mt-2 cursor-pointer">
                          <img :src="require('@/assets/images/doc-validation.svg')" alt="not_found">
                          <p class="font-normal text-sm text-darkPurple">Validate</p>
                        </div>
                      </div>
                      <div v-if="canValidateOrInvalidate" class="w-full" @click="updateReliefsStatus(data.id, 'disapproved')">
                        <div class="w-full flex justify-start items-center gap-2 mt-2 cursor-pointer">
                          <img :src="require('@/assets/images/doc-invalid.svg')" alt="not_found">
                          <p class="font-normal text-sm text-darkPurple">Invalidate</p>
                        </div>
                      </div>
                    </div>
                    <div class="w-48 flex flex-col justify-start items-center gap-3 px-3 py-2" v-else>
                      <div v-if="canValidateOrInvalidate" class="w-full" @click="viewRelief(data)">
                        <div class="w-full flex justify-start items-center gap-2 cursor-pointer">
                          <Icon icon-name="icon-eye" class-name="text-blueCrayola" size="xs" />
                          <p class="font-normal text-sm text-darkPurple">View</p>
                        </div>
                      </div>
                      <div v-if="canValidateOrInvalidate" class="w-full" @click="updateReliefsStatus(data.id, 'pending')">
                        <div class="w-full flex justify-start items-center gap-2 mt-2 cursor-pointer">
                          <img :src="require('@/assets/images/revert-icon.svg')" alt="not_found">
                          <p class="font-normal text-sm text-darkPurple">Revert</p>
                        </div>
                      </div>
                    </div>
                  </Menu>
              </td>
            </tr>
            <tr class="h-7" />
          </tbody>
        </table>
        <div class="flex text-jet text-sm flex-col justify-center items-center w-full p-8 m-8 gap-2" v-else>
          <img :src="require('@/assets/images/cash-bag.svg')" alt="not_found">
          <p class="font-black text-xs uppercase">
            No  relief added yet
          </p>
          <p>Submitted employee reliefs will display here once added.</p>
        </div>
      </div>
      <History v-if="currentTab === 'History'" 
        :employee-reliefs-history="employeeReliefsHistory"
      />
    </div>

    <ViewRelief v-if="isViewRelief"
      :relief="selectedItem"
      @close="isViewRelief = false"
    />
  </div>
</template>

<script>
import Tab from "@scelloo/cloudenly-ui/src/components/tab";
import Menu from "@/components/Menu";
import ViewRelief from "@/components/ViewRelief";
import History from "./history";

export default {
  components: { Tab, Menu,  ViewRelief, History },
  props: {
    title: {
      type: String,
      default: ""
    },
    employeeReliefs: {
      type: Array,
      default() {
        return [];
      }
    },
    employeeReliefsHistory: {
      type: Array,
      default() {
        return [];
      }
    },
    employeeUserId: {
      type: String,
      default: ""
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      headers: [
        { title: "relief type" },
        { title: "Annual figure" },
        { title: "date submitted" },
        { title: "last updated" },
        { title: "status" },
        { title: "attachment" },
        { title: " " }
      ],
      tabs: [
        "Current Relief",
        "History"
      ],
      currentTab: "Current Relief",
      isViewRelief: false,
      selectedItem: {},
      canValidateOrInvalidate: false,
    };
  },
  computed: {
  },
  methods: {
    viewRelief(data){
      this.isViewRelief = true;
      this.selectedItem = data
    },
    viewFile(fileUrl) {
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = "";
      link.click();
    },
    async updateReliefsStatus(id, newStatus){
      try {
        await this.$handlePrivilege('employeeDirectory', 'validateOrInvalidateReliefs');
        this.$emit('update-reliefs-status', id, newStatus);
      } catch (error) {
        this.$toasted.error('You do not have permission to validate or invalidate reliefs', {
          duration: 5000
        });
      }
    }
  },
  async mounted() {
    try {
      await this.$handlePrivilege('employeeDirectory', 'validateOrInvalidateReliefs');
      this.canValidateOrInvalidate = true;
    } catch (error) {
      this.canValidateOrInvalidate = false;
    }
  }
};
</script>

<style scoped>
.line{
  border: 0.5px solid #00000029;
  width: 100%;
  height: 0;
  margin: 10px auto;
  border-radius: 10px;
  padding: 0;
}
.grosspay {
  background: #2176ff26;
  padding: 0.3rem 0.7rem;
  color: #2176ff;
  border-radius: 5px;
}
</style>
